import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { calcDistance, setOrderMethod } from '../../actions/orderActions'
import OrderMethodItem from '../../components/desktop/cart/OrderMethodItem'
import { ACCESS_SERVICES_MAP, ORDER_METHOD } from '../../constants'
import { getRestaurantServices } from '../../selectors'
import { getDeliverInfo } from '../../selectors/order'
import { makeAddressCalcDistance } from '../../utils'
import { clsx } from '../../utils/helper'

const OrderMethodContainer = () => {
    const { orderMethod } = useSelector(state => state.OrderReducer)
    const services = useSelector(getRestaurantServices)
    const deliverInfo = useSelector(getDeliverInfo)
    const { selectAddress, distance, userAddressNumber, userStreet, userCity, userPostcode } =
        deliverInfo

    const dispatch = useDispatch()
    const { t } = useTranslation()

    const handleChangeOrderMethod = method => {
        if (
            method === ORDER_METHOD.DELIVERY &&
            distance !== 0 &&
            !distance &&
            selectAddress &&
            selectAddress !== '-1' &&
            userAddressNumber &&
            userStreet &&
            userCity &&
            userPostcode
        ) {
            dispatch(
                calcDistance({
                    params: {
                        destinations: makeAddressCalcDistance(userStreet, userAddressNumber, userCity, userPostcode),
                    },
                })
            )
        }
        dispatch(setOrderMethod(method))
    }

    const orderMethods = [
        services.includes(ACCESS_SERVICES_MAP[ORDER_METHOD.DELIVERY]) && {
            label: t('cartDesktop.lbDeliver'),
            value: ORDER_METHOD.DELIVERY,
        },
        services.includes(ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP]) && {
            label: t('cartDesktop.lbPickup'),
            value: ORDER_METHOD.PICKUP,
        },
    ].filter(Boolean)

    return (
        <div className="order-method">
            <div className="title">{t('cartDesktop.lbOrderMethod')}</div>
            <div className="order-method__list">
                {orderMethods.map((orderMethodItem, index) => (
                    <OrderMethodItem
                        key={index}
                        type={orderMethodItem.value}
                        label={orderMethodItem.label}
                        className={clsx([
                            index && 'ml-4',
                            orderMethodItem.value === orderMethod && ' active',
                        ])}
                        onClick={() =>
                            handleChangeOrderMethod(orderMethodItem.value)
                        }
                    />
                ))}
            </div>
        </div>
    )
}

export default OrderMethodContainer
